import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTonda = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 16" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-16",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "tonda",
				transform: "translate(194.444444, 277.777778)",
				children: [/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-Copy-14",
					stroke: "#0056C1",
					strokeWidth: 28,
					x: 208.444444,
					y: 69.5555556,
					width: 194.222222,
					height: 305.333333
				}), /* @__PURE__ */ _jsx("path", {
					d: "M128.5,448.5 C114.833333,436.5 102.416667,422.5 91.25,406.5 C80.0833333,390.5 70.5,373.5 62.5,355.5 C54.5,337.5 48.3333333,319.166667 44,300.5 C39.6666667,281.833333 37.5,263.666667 37.5,246 L37.5,246 L37.5,203 C37.5,185.666667 39.6666667,167.666667 44,149 C48.3333333,130.333333 54.4166667,112 62.25,94 C70.0833333,76 79.5833333,59 90.75,43 C101.916667,27 114.5,12.6666667 128.5,0 L128.5,0 L90.5,0 C77.8333333,11 66,24.3333333 55,40 C44,55.6666667 34.4166667,73.0833333 26.25,92.25 C18.0833333,111.416667 11.6666667,132.166667 7,154.5 C2.33333333,176.833333 0,200 0,224 C0,248.333333 2.41666667,271.75 7.25,294.25 C12.0833333,316.75 18.5833333,337.666667 26.75,357 C34.9166667,376.333333 44.5,393.833333 55.5,409.5 C66.5,425.166667 78.1666667,438.166667 90.5,448.5 L90.5,448.5 L128.5,448.5 Z M515.5,448.5 C527.833333,438.166667 539.5,425.166667 550.5,409.5 C561.5,393.833333 571.083333,376.333333 579.25,357 C587.416667,337.666667 593.916667,316.75 598.75,294.25 C603.583333,271.75 606,248.333333 606,224 C606,200 603.666667,176.833333 599,154.5 C594.333333,132.166667 587.916667,111.416667 579.75,92.25 C571.583333,73.0833333 562,55.6666667 551,40 C540,24.3333333 528.166667,11 515.5,0 L515.5,0 L477.5,0 C491.5,12.6666667 504.083333,27 515.25,43 C526.416667,59 535.916667,76 543.75,94 C551.583333,112 557.666667,130.333333 562,149 C566.333333,167.666667 568.5,185.666667 568.5,203 L568.5,203 L568.5,246 C568.5,263.666667 566.25,281.833333 561.75,300.5 C557.25,319.166667 551,337.5 543,355.5 C535,373.5 525.416667,390.5 514.25,406.5 C503.083333,422.5 490.833333,436.5 477.5,448.5 L477.5,448.5 L515.5,448.5 Z",
					id: "()",
					fill: "#424548",
					fillRule: "nonzero"
				})]
			})]
		})
	})]
});
export default SvgTonda;
